import React from 'react';
import { FormSummary, FlexGridItem, Box } from '@alinta-digital/asg';
import { FuelSite } from '../../types';
import { SummaryProps } from '../../types';
import { FormContainerContext } from '../../contexts/FormContainerContext';
import { pushAnalytics, resetFormContextError } from '../../utils/utils';
import { StyledText } from '../../Common.Styled';

interface ConnectionSummaryProps extends SummaryProps {
  selectedElectricity: FuelSite[];
  selectedGas: FuelSite[];
}

export const ConnectionSummary: React.FunctionComponent<ConnectionSummaryProps> = ({
  selectedElectricity,
  selectedGas,
  showSummaryFields,
  onEditClick,
}) => {
  const {
    values: formContextValues,
    dispatch: formContextDispatch,
  } = React.useContext(FormContainerContext);

  React.useEffect(() => {
    showSummaryFields && pushAnalytics('load.0.directdebitstep2.edit');
  }, []);

  return (
    <FormSummary
      heading="Step 2: Your connection"
      body={
        showSummaryFields ? (
          <>
            {selectedElectricity.length > 0 && (
              <FlexGridItem md={6}>
                <StyledText size="small" weight="bold">
                  Current Plan
                </StyledText>
                <br />
                <StyledText size="medium">Electricity</StyledText>
                <br />
                {selectedElectricity.map((site: FuelSite, idx: number) => (
                  <React.Fragment key={`${site.accountNumber}`}>
                    <StyledText size="medium" data-testid="electricitySummary">
                      Account number: {site.authAccountNumber}
                    </StyledText>
                    {selectedElectricity.length !== idx + 1 && (
                      <Box margin={{ bottom: 'xxsmall' }} />
                    )}
                  </React.Fragment>
                ))}
              </FlexGridItem>
            )}

            {selectedGas.length > 0 && (
              <FlexGridItem md={6}>
                <StyledText size="small" weight="bold">
                  Current Plan
                </StyledText>
                <br />
                <StyledText size="medium">Gas</StyledText>
                <br />
                {selectedGas.map((site: FuelSite, idx: number) => (
                  <React.Fragment key={`${site.accountNumber}`}>
                    <StyledText size="medium" data-testid="gasSummary">
                      Account number: {site.authAccountNumber}
                    </StyledText>
                    {selectedGas.length !== idx + 1 && (
                      <Box margin={{ bottom: 'xxsmall' }} />
                    )}
                  </React.Fragment>
                ))}
              </FlexGridItem>
            )}
          </>
        ) : (
          undefined
        )
      }
      onEditClick={
        showSummaryFields
          ? () => {
              resetFormContextError(formContextValues, formContextDispatch, 1);
              pushAnalytics('click.1.directdebitstep2.edit');
              onEditClick();
            }
          : undefined
      }
    />
  );
};
